import { type ISummaryItem } from "../../../../../../pages/Summary/Summary.types";
import { DateTimeDisp } from "src/components/shared/DateTime";
import { StyledTd } from "../../../../../../styled";
import { ReviewText } from "../../ReviewsTable.styled";

interface Props {
  isMedicalLog: boolean | undefined;
  row: ISummaryItem;
  disabled: boolean | undefined;
  red?: boolean;
}

const EntryDateOrPatientCell = ({
  isMedicalLog,
  disabled,
  row,
  red,
}: Props) => {
  return (
    <StyledTd center red={red}>
      <ReviewText fz="13px" disabled={disabled}>
        {!isMedicalLog && (
          <DateTimeDisp
            color="blue"
            utc={row.entrydateUTC}
            utcOffset={row.datecreatedOffset}
            lt={row.sortdate ?? row.entrydate}
            disabled={disabled}
          />
        )}
        {isMedicalLog && (
          <p>{row.subject?.patient ? row.subject.patient : ""}</p>
        )}
      </ReviewText>
      <ReviewText fz="13px" disabled={disabled}>
        {isMedicalLog && row.subject?.diagnosis
          ? row?.subject?.diagnosis.map((v: string, i) => {
              return <p key={`d-${row.lbeid}-${i}`}>{v}</p>;
            })
          : ""}
      </ReviewText>
    </StyledTd>
  );
};
export default EntryDateOrPatientCell;
